export enum ORDER_BY {
  ALL = '',
  LIKES = 'likes',
  RECENT = '-publication_date',
  OLDEST = 'publication_date',
}
